// Web reports a denial as code 1, Capacitor 8 as OS-PLUG-GLOC-0003, or OS-PLUG-GLOC-0008 when iOS restricts location
const deniedCodes: unknown[] = [1, 'OS-PLUG-GLOC-0003', 'OS-PLUG-GLOC-0008']

export const isLocationPermissionDeniedError = (error: unknown) => {
  if (typeof error !== 'object' || error === null) return false

  if ('code' in error && deniedCodes.includes(error.code)) return true

  // iOS can report a denial as CoreLocation's kCLErrorDenied in the message, with no code
  return (
    'message' in error &&
    typeof error.message === 'string' &&
    error.message.includes('kCLErrorDomain error 1.')
  )
}
